<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Asignar Autoridad</div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="AuthotitySelectForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="sex"
                    >Autoridad *</label>
                    <div class="relative">
                      <select
                        v-model="selectAuthority"
                        name="selectAuthority"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione uno</option>
                        <template v-for="authority in authorities">
                          <option :key="authority.id" :value="authority.id">{{authority.name}} {{authority.last_name}} (conectado {{authority.diff }})</option>
                        </template>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.selectAuthority"
                      class="text-red-500 text-xs italic pt-3"
                    >Seleccione una autoridad.</p>
                  </div>
                </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveAuthority()"
                >Guardar</button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Authoridad asignada exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import moment from "moment";

export default {
  data() {
    return {
      selectAuthority: null,
      authorities: [],
      alert: null,
      errors: {
        selectAuthority: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("asignModal", this.setData);
    this.fetchActiveAuthorities();
  },
  components: {
    AlertDialog
  },
  methods: {
    reset: function() {
      this.selectAuthority =  null;
      this.alert = null;
      this.errors = {
        selectAuthority: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    fetchActiveAuthorities() {
      this.axios
        .get("apidev/authorities/active/list/", this.config)
        .then(response => {
          response.data.authorities.forEach(data=>{
            var a = moment(data.last_date);
            var b = moment(data.now);
            data.diff = a.from(b);
          })
          this.authorities = response.data.authorities;

        })
        .catch(error => {
          console.log(error)
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    setData: function(alert) {
      this.alert = Object.assign({}, alert);
      this.fetchActiveAuthorities();
    },

    saveAuthority() {
      const form = document.getElementById("AuthotitySelectForm");
      const signInData = new FormData(form);
      const validForm = this.checkFormSelectAuthority(signInData);

      if (validForm) {
        //implement code for create new authorityType
        this.axios
          .post(
            "apidev/api/alerts/assign/authority/",
            {
              autoridad_id: this.selectAuthority,
              alert_id: this.alert.id
            },
            this.config
          )
          .then(response => {
            let authority = this.authorities.find(authority => authority.id == this.selectAuthority);
            if(authority){
              return this.axios.post("apidev/api/binnacles/monitor/save/",{
                "module": "Alertas", 
                "action": "Asignación de una alerta a una autoridad",
                "observation": `Alerta F-${this.alert.id} a ${authority.name} ${authority.last_name}`,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            }else{
              return Promise.resolve()
            }
          })
          .then(response => {
            this.showingSuccess = true; 
            this.$emit("updateAllAlerts");
            this.reset();
            this.$emit("close");
          })
          .catch(error => {
            if (error.response.status == 400 || error.response.status == 401) {
              if (error.response.data.name === 'TokenExpiredError' || 
                  error.response.data.name === 'InvalidTokenError' || 
                  error.response.data.name === 'JsonWebTokenError') {
              this.$router.push({path: '/login'}); 
              }
            }
            this.showingError = true;
          });
      }
    },

    checkFormSelectAuthority: function(signInData) {
      if (signInData.get("selectAuthority") === null) {
        this.errors.selectAuthority = true;
      } else {
        this.errors.selectAuthority = false;
      }

      if (this.errors.selectAuthority){
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
